"use client";

import { cn } from "@medimo/ui";
import { EditorContent, type EditorContentProps } from "@tiptap/react";
import type React from "react";
import type { HTMLAttributes } from "react";
import "../styles/styles.css";

type StyledEditorProps = Omit<EditorContentProps, "ref"> &
  Pick<HTMLAttributes<HTMLDivElement>, "className"> & {
    disabled?: boolean;
    editorRef?: React.RefObject<HTMLDivElement | null>;
    placeholder?: string;
  };

export const StyledEditor = ({
  className,
  disabled,
  editorRef,
  placeholder: _placeholder,
  ...props
}: StyledEditorProps) => {
  return (
    <EditorContent
      ref={editorRef}
      className={cn(
        `rounded-md border-2 text-xl ${
          disabled &&
          "w-full overflow-hidden whitespace-pre-wrap break-words border-none p-0 [&_a:active]:text-red-500 [&_a:focus]:outline [&_a:focus]:outline-2 [&_a:focus]:outline-light-blue-500 [&_a:hover]:text-blue-800 [&_a:hover]:no-underline [&_a:visited]:text-purple-500 [&_a]:text-blue-500 [&_a]:underline"
        }
        `,
        className,
      )}
      {...props}
    />
  );
};
